import ArcLoading from "components/ArcLoading";
import { CallButton, ReentryFrame } from "pages/QuoteFlow/ReentryParts";

import { CONTINUE_BUTTON_CLASS } from "components/FormV2";

import { PENDING_RETRY_LABEL, pendingCopyFor } from "./verify";

/**
 * What a visitor sees while their own submission is still being finished:
 * the wait while the page asks again, then, once the attempts are used up,
 * another try beside the number to call.
 */
export default function Pending({
  retrying,
  line,
  onRetry,
}: {
  retrying: boolean;
  line: { href: string; label: string };
  onRetry: () => void;
}) {
  const copy = pendingCopyFor(retrying);
  return (
    <ReentryFrame>
      <h1 className="font-serif text-[25px] leading-tight text-soil sm:text-[31px]">
        {copy.title}
      </h1>
      <p className="text-base text-oat-700" role="status">
        {copy.body}
      </p>
      {retrying ? (
        <ArcLoading className="h-8 w-[130px] text-soil" />
      ) : (
        <div className="flex w-full flex-col items-center gap-3">
          <button
            type="button"
            className={CONTINUE_BUTTON_CLASS}
            onClick={onRetry}
          >
            {PENDING_RETRY_LABEL}
          </button>
          <CallButton
            line={line}
            track={{ surface: "verify", screen: "pending" }}
          />
        </div>
      )}
    </ReentryFrame>
  );
}
